var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items-box"},_vm._l((_vm.items),function(item,index){return _c('img',{key:index,staticClass:"icon-size",attrs:{"src":item.icon}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }